import {config} from '../config';

export default {
    getMinYearDate: () => config.data.dates.minYearDate,
};
